import React, { useEffect } from 'react';

import { useQuery, useNavigate, useParams } from '@common/hooks';
import { AppContent, Tabs } from '@common/components';
import { setBreadcrumbs } from 'works/legacy/lib/client-store';
import { WorkerTimesheetsTab } from '@timekeeping/components';
import { WorkerTimesheetStatusCounts } from '@timekeeping/graphql';
import { useDefaultTimesheetTabCounts } from '@timekeeping/hooks';

export const TimesheetsPage = () => {
  const navigate = useNavigate();
  const params = useParams<{ tab: string }>();
  const tab = params.tab || 'submitted';

  useEffect(() => {
    setBreadcrumbs([{ name: 'Timecards', path: '/works/supplier/timecards' }]);
  }, []);

  const countsQuery = useQuery(WorkerTimesheetStatusCounts);
  const defaultTabs = useDefaultTimesheetTabCounts();
  const counts = countsQuery.data?.counts || defaultTabs;

  const handleTabChange = (tab: string) => {
    navigate(`/works/supplier/timecards/${tab}`);
  };

  return (
    <div className="TimesheetsPage">
      <AppContent>
        <Tabs defaultActiveKey={tab} onChange={handleTabChange}>
          {counts.map((count) => (
            <Tabs.Pane
              key={count.id}
              tab={<Tabs.Tab title={count.name} count={count.value} />}
            >
              <WorkerTimesheetsTab count={count} entity="supplier" />
            </Tabs.Pane>
          ))}
        </Tabs>
      </AppContent>
      <style jsx>{`
        .TimesheetsPage :global(.ant-tabs-tab) {
          min-width: 114px;
        }
      `}</style>
    </div>
  );
};
